"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _isFinite2 = _interopRequireDefault(require("lodash/isFinite"));
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
var _split2 = _interopRequireDefault(require("lodash/split"));
var _filters = require("../../constants/filters.constants");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PriceFilter = exports.default = (_dec = _mobx.observable.shallow, _dec2 = _mobx.observable.shallow, _dec3 = _mobx.observable.shallow, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, _dec7 = _mobx.action.bound, _dec8 = _mobx.action.bound, _dec9 = _mobx.action.bound, _dec10 = _mobx.action.bound, _dec11 = _mobx.action.bound, (_class = function () {
  function PriceFilter(filterData, $env) {
    (0, _classCallCheck2.default)(this, PriceFilter);
    this.$env = void 0;
    this.id = _filters.FILTER_MAP.PRICE;
    (0, _initializerDefineProperty2.default)(this, "data", _descriptor, this);
    (0, _initializerDefineProperty2.default)(this, "state", _descriptor2, this);
    (0, _initializerDefineProperty2.default)(this, "uncommittedState", _descriptor3, this);
    (0, _initializerDefineProperty2.default)(this, "isTouched", _descriptor4, this);
    this.$env = $env;
    this.initialize(filterData);
  }
  (0, _createClass2.default)(PriceFilter, [{
    key: "currency",
    get: function get() {
      return this.$env.currency.currentCurrency;
    }
  }, {
    key: "query",
    get: function get() {
      return this.isPristine ? undefined : [this.state.from, this.state.to].join(_filters.FILTER_SEPARATOR_MAP.RANGE);
    }
  }, {
    key: "params",
    get: function get() {
      return this.state;
    }
  }, {
    key: "isDirty",
    get: function get() {
      return !this.isPristine || this.isUncommitted;
    }
  }, {
    key: "isPristine",
    get: function get() {
      return this.state.from === this.state.min && this.state.to === this.state.max;
    }
  }, {
    key: "isUncommitted",
    get: function get() {
      return this.state.from !== this.uncommittedState.from || this.state.to !== this.uncommittedState.to;
    }
  }, {
    key: "isReady",
    get: function get() {
      return this.data.max > 0;
    }
  }, {
    key: "filter",
    value: function filter(price) {
      return price >= this.uncommittedState.from && price <= this.uncommittedState.to;
    }
  }, {
    key: "initialize",
    value: function initialize(data, query, withCommit) {
      if (query === void 0) {
        query = "";
      }
      if (withCommit === void 0) {
        withCommit = true;
      }
      this.data = data;
      var min = data.min,
        max = data.max;
      this.uncommittedState = {
        min: min,
        max: max,
        from: min,
        to: max,
        currency: this.currency
      };
      if (withCommit) {
        this.state = this.uncommittedState;
      }
      if (query) {
        this.update(query, withCommit);
      }
    }
  }, {
    key: "set",
    value: function set(payload, withCommit) {
      if (withCommit === void 0) {
        withCommit = false;
      }
      if ((0, _isPlainObject2.default)(payload)) {
        var _this$uncommittedStat = this.uncommittedState,
          min = _this$uncommittedStat.min,
          max = _this$uncommittedStat.max;
        this.uncommittedState = _objectSpread(_objectSpread({}, this.uncommittedState), {}, {
          from: (0, _isFinite2.default)(payload.from) && payload.from >= min ? payload.from : this.uncommittedState.from,
          to: (0, _isFinite2.default)(payload.to) && payload.to <= max ? payload.to : this.uncommittedState.to
        });
      }
      withCommit && this.commit();
    }
  }, {
    key: "update",
    value: function update(query, withCommit) {
      if (withCommit === void 0) {
        withCommit = false;
      }
      if (!query) {
        this.reset(withCommit);
      } else {
        var _split$map = (0, _split2.default)(query, _filters.FILTER_SEPARATOR_MAP.RANGE).map(Number),
          from = _split$map[0],
          to = _split$map[1];
        this.set({
          from: from,
          to: to
        });
        withCommit && this.commit();
      }
    }
  }, {
    key: "commit",
    value: function commit() {
      this.state = this.uncommittedState;
      this.isTouched = true;
    }
  }, {
    key: "revert",
    value: function revert() {
      this.uncommittedState = this.state;
    }
  }, {
    key: "reset",
    value: function reset(withCommit) {
      if (withCommit === void 0) {
        withCommit = false;
      }
      this.initialize(this.data, undefined, withCommit);
    }
  }, {
    key: "clone",
    value: function clone(filterState) {
      this.state = _objectSpread(_objectSpread({}, this.state), {}, {
        from: filterState.from,
        to: filterState.to
      });
      this.uncommittedState = _objectSpread(_objectSpread({}, this.uncommittedState), {}, {
        from: filterState.from,
        to: filterState.to
      });
    }
  }]);
  return PriceFilter;
}(), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "data", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "state", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "uncommittedState", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isTouched", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "currency", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currency"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "query", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "query"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "params", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "params"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isDirty", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDirty"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isPristine", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPristine"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isUncommitted", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isUncommitted"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isReady", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isReady"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "filter", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "filter"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "initialize", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "initialize"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "set", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "set"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "update", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "update"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "commit", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "commit"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "revert", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "revert"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "reset", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "reset"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "clone", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "clone"), _class.prototype)), _class));